import { render, staticRenderFns } from "./TesimonialsCard.vue?vue&type=template&id=5ea2edc9&scoped=true&"
import script from "./TesimonialsCard.vue?vue&type=script&lang=js&"
export * from "./TesimonialsCard.vue?vue&type=script&lang=js&"
import style0 from "./TesimonialsCard.vue?vue&type=style&index=0&id=5ea2edc9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea2edc9",
  null
  
)

export default component.exports